/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 128:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseIDLToAST = parseIDLToAST;
const nearley_1 = __webpack_require__(662);
const grammar_1 = __webpack_require__(836);
/** Uses the IDL grammar to initialize and use a Nearley parser to read the string argument
 * @returns - array of parsed IDL definitions
 */
function parseIDLToAST(definition) {
    const parser = new nearley_1.Parser(grammar_1.IDL_GRAMMAR);
    parser.feed(definition);
    parser.finish();
    const results = parser.results;
    if (results.length === 0) {
        throw new Error(`Could not parse message definition (unexpected end of input): '${definition}'`);
    }
    if (results.length > 1) {
        throw new Error(`Ambiguous grammar: '${definition}'`);
    }
    // narrowed it down to 1 array of definitions
    return results[0];
}


/***/ }),

/***/ 165:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IDLNode = void 0;
exports.toScopedIdentifier = toScopedIdentifier;
/** Class used to resolve ASTNodes to IDLMessageDefinitions
 * There is a subclass of this class for each `declarator` type on the ASTNode.
 * This class is meant to provide functions and variables that exist across all of the nodes to help them resolve to complete message definitions.
 */
class IDLNode {
    /** Map of all IDLNodes in a schema definition */
    map;
    /** Unresolved node parsed directly from schema */
    astNode;
    /** Array of strings that represent namespace scope that astNode is contained within. */
    scopePath;
    constructor(scopePath, astNode, idlMap) {
        this.scopePath = scopePath;
        this.astNode = astNode;
        this.map = idlMap;
    }
    get declarator() {
        return this.astNode.declarator;
    }
    get name() {
        return this.astNode.name;
    }
    get annotations() {
        return this.astNode.annotations;
    }
    /** Returns scoped identifier of the astNode: (...scopePath::name) */
    get scopedIdentifier() {
        return toScopedIdentifier([...this.scopePath, this.name]);
    }
    /** Gets any node in map. Fails if not found.*/
    getNode(scopePath, name) {
        const maybeNode = resolveScopedOrLocalNodeReference({
            usedIdentifier: name,
            scopeOfUsage: scopePath,
            definitionMap: this.map,
        });
        if (maybeNode == undefined) {
            throw new Error(`Could not find node ${name} in ${scopePath.join("::")} referenced by ${this.scopedIdentifier}`);
        }
        return maybeNode;
    }
    /** Gets a constant node under a local-to-this-node or scoped identifier. Fails if not a ConstantNode */
    getConstantNode(identifier, scopePath = this.scopePath) {
        const maybeConstantNode = this.getNode(scopePath, identifier);
        if (maybeConstantNode.declarator !== "const") {
            throw new Error(`Expected ${this.name} to be a constant in ${this.scopedIdentifier}`);
        }
        return maybeConstantNode;
    }
}
exports.IDLNode = IDLNode;
/** Takes a potentially scope-less name used in a given scope and attempts to find the Node in the map
 * that matches it's name in the local scope or any larger encapsulating scope.
 * For example:
 * ```Cpp
 * module foo {
 * typedef customType uint32;
 * module bar {
 *   customType FooBar;
 *   foo::customType BarFoo;
 * };
 * };
 * ```
 * Both of these usages of customType should resolve given this function.
 */
function resolveScopedOrLocalNodeReference({ usedIdentifier, scopeOfUsage, definitionMap, }) {
    // If using local un-scoped identifier, it will not be found in the definitions map
    // In this case we try by building up the namespace prefix until we find a match
    let referencedNode = undefined;
    // start with most specific scope and work upwards
    const currPrefix = [...scopeOfUsage];
    for (;;) {
        const identifierToTry = toScopedIdentifier([...currPrefix, usedIdentifier]);
        referencedNode = definitionMap.get(identifierToTry);
        if (referencedNode != undefined) {
            break;
        }
        if (currPrefix.length === 0) {
            break;
        }
        currPrefix.pop();
    }
    return referencedNode;
}
function toScopedIdentifier(path) {
    return path.join("::");
}


/***/ }),

/***/ 177:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildMap = buildMap;
exports.toIDLMessageDefinitions = toIDLMessageDefinitions;
const IDLNodes_1 = __webpack_require__(334);
const UnionIDLNode_1 = __webpack_require__(522);
/** Initializes map of IDL nodes to their scoped namespaces */
function buildMap(definitions) {
    const idlMap = new Map();
    for (const definition of definitions) {
        // build flattened definition map
        traverseIDL([definition], (path) => {
            const node = path[path.length - 1];
            const namePath = path.map((n) => n.name);
            const scopePath = namePath.slice(0, -1);
            const newNodes = makeIDLNode(scopePath, node, idlMap);
            idlMap.set(newNodes.scopedIdentifier, newNodes);
            if (node.declarator === "enum") {
                // DDS X-Types spec section 7.3.1.2.1.5: Enumerated Literal Values
                // How C++ does implicit enums is that they will increment after the last explicit enum
                // even if it collides with an existing enum
                // initialize to -1 so that first value is 0
                let prevEnumValue = -1;
                const enumConstants = node.enumerators.flatMap((m) => {
                    const enumValue = getValueAnnotation(m.annotations) ?? ++prevEnumValue;
                    if (typeof enumValue !== "number") {
                        throw new Error(
                        // eslint-disable-next-line @typescript-eslint/no-base-to-string
                        `Enum value, ${enumValue?.toString() ?? "undefined"}, assigned to ${node.name}::${m.name} must be a number`);
                    }
                    prevEnumValue = enumValue;
                    return {
                        declarator: "const",
                        isConstant: true,
                        name: m.name,
                        type: "unsigned long",
                        value: enumValue,
                        isComplex: false,
                    };
                });
                // Enum scope constants
                for (const constant of enumConstants) {
                    const idlConstantNode = new IDLNodes_1.ConstantIDLNode(namePath, constant, idlMap);
                    idlMap.set(idlConstantNode.scopedIdentifier, idlConstantNode);
                }
                // enums constants can be referred to by their Enum::VALUE or by their parent module followed by ::VALUE.
                // Ex: Test::Colors::RED or Test::RED
                const moduleLevelNamePath = namePath.slice(0, -1);
                for (const constant of enumConstants) {
                    const idlConstantNode = new IDLNodes_1.ConstantIDLNode(moduleLevelNamePath, constant, idlMap);
                    idlMap.set(idlConstantNode.scopedIdentifier, idlConstantNode);
                }
            }
        });
    }
    return idlMap;
}
function getValueAnnotation(annotations) {
    if (!annotations) {
        return undefined;
    }
    const valueAnnotation = annotations["value"];
    if (valueAnnotation && valueAnnotation.type === "const-param") {
        return valueAnnotation.value;
    }
    return undefined;
}
/** Convert to IDL Message Definitions for serialization and compatibility with Foxglove's Raw Message panel. Returned in order of original definitions*/
function toIDLMessageDefinitions(map) {
    const messageDefinitions = [];
    // flatten for output to message definition
    // Because the map entries are in original insertion order, they should reflect the original order of the definitions
    // This is important for ros2idl compatibility
    for (const node of map.values()) {
        if (node.declarator === "struct") {
            messageDefinitions.push(node.toIDLMessageDefinition());
        }
        else if (node.declarator === "module") {
            const def = node.toIDLMessageDefinition();
            if (def != undefined) {
                messageDefinitions.push(def);
            }
        }
        else if (node.declarator === "const") {
            // Don't need constants for deserialization, all constant usage should be resolved by now.
            // This does not omit enum constants from output because they are added under the enum toIDLMessageDefinition.
        }
        else if (node.declarator === "enum") {
            messageDefinitions.push(node.toIDLMessageDefinition());
        }
        else if (node.declarator === "union") {
            messageDefinitions.push(node.toIDLMessageDefinition());
        }
    }
    return messageDefinitions;
}
const makeIDLNode = (scopePath, node, idlMap) => {
    switch (node.declarator) {
        case "module":
            return new IDLNodes_1.ModuleIDLNode(scopePath, node, idlMap);
        case "enum":
            return new IDLNodes_1.EnumIDLNode(scopePath, node, idlMap);
        case "const":
            return new IDLNodes_1.ConstantIDLNode(scopePath, node, idlMap);
        case "struct":
            return new IDLNodes_1.StructIDLNode(scopePath, node, idlMap);
        case "struct-member":
            return new IDLNodes_1.StructMemberIDLNode(scopePath, node, idlMap);
        case "typedef":
            return new IDLNodes_1.TypedefIDLNode(scopePath, node, idlMap);
        case "union":
            return new UnionIDLNode_1.UnionIDLNode(scopePath, node, idlMap);
    }
};
/**
 * Iterates through IDL tree and calls `processNode` function on each node.
 * NOTE: Does not process enum members
 */
function traverseIDL(path, processNode) {
    const currNode = path[path.length - 1];
    if ("definitions" in currNode) {
        currNode.definitions.forEach((n) => {
            traverseIDL([...path, n], processNode);
        });
    }
    processNode(path);
}


/***/ }),

/***/ 330:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TypedefIDLNode = void 0;
const ReferenceTypeIDLNode_1 = __webpack_require__(852);
class TypedefIDLNode extends ReferenceTypeIDLNode_1.ReferenceTypeIDLNode {
}
exports.TypedefIDLNode = TypedefIDLNode;


/***/ }),

/***/ 334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(877), exports);
__exportStar(__webpack_require__(774), exports);
__exportStar(__webpack_require__(165), exports);
__exportStar(__webpack_require__(453), exports);
__exportStar(__webpack_require__(393), exports);
__exportStar(__webpack_require__(572), exports);
__exportStar(__webpack_require__(330), exports);


/***/ }),

/***/ 393:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StructIDLNode = void 0;
const IDLNode_1 = __webpack_require__(165);
class StructIDLNode extends IDLNode_1.IDLNode {
    get type() {
        return this.astNode.name;
    }
    get definitions() {
        return this.astNode.definitions.map((def) => this.getStructMemberNode(def.name));
    }
    /** Writes out struct as IDL Message definition with resolved `definitions` members */
    toIDLMessageDefinition() {
        const definitions = this.definitions.map((def) => def.toIDLMessageDefinitionField());
        return {
            name: this.scopedIdentifier,
            definitions,
            aggregatedKind: "struct",
            ...(this.astNode.annotations ? { annotations: this.astNode.annotations } : undefined),
        };
    }
    /** Gets node within struct by its local name (unscoped) */
    getStructMemberNode(name) {
        const maybeStructMember = this.getNode([...this.scopePath, this.name], name);
        if (maybeStructMember.declarator !== "struct-member") {
            throw new Error(`Expected ${name} to be a struct member in ${this.scopedIdentifier}`);
        }
        return maybeStructMember;
    }
}
exports.StructIDLNode = StructIDLNode;


/***/ }),

/***/ 428:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 453:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ModuleIDLNode = void 0;
const ConstantIDLNode_1 = __webpack_require__(877);
const IDLNode_1 = __webpack_require__(165);
class ModuleIDLNode extends IDLNode_1.IDLNode {
    /** Writes out module to message definition that contains only its directly descendent constant definitions */
    toIDLMessageDefinition() {
        const definitions = this.definitions.flatMap((def) => {
            if (def instanceof ConstantIDLNode_1.ConstantIDLNode) {
                return [def.toIDLMessageDefinitionField()];
            }
            return [];
        });
        if (definitions.length === 0) {
            return undefined;
        }
        return {
            name: this.scopedIdentifier,
            definitions,
            aggregatedKind: "module",
        };
    }
    get definitions() {
        return this.astNode.definitions.map((def) => this.getNode([...this.scopePath, this.name], def.name));
    }
}
exports.ModuleIDLNode = ModuleIDLNode;


/***/ }),

/***/ 506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// Generated automatically by nearley, version unknown
// http://github.com/Hardmath123/nearley
(function () {
function id(x) { return x[0]; }


// necessary to use keywords to avoid using the `reject` postprocessor which can cause poor perf
// having these as keywords removes ambiguity with `customType` rule
const keywords = [
  , "struct"
  , "module"
  , "enum"
  , "const"
  , "typedef"
  , "union"
  , "switch"
  , "case"


  //types
  , "boolean"
  , "wstring"
  , "string"
  , "sequence"

  // Boolean types
  , "TRUE"
  , "FALSE"

  // numeric types
  , "byte"
  , "octet"
  , "wchar"
  , "char"
  , "double"
  , "float"
  , "int8"
  , "uint8"
  , "int16"
  , "uint16"
  , "int32"
  , "uint32"
  , "int64"
  , "uint64"
  , "unsigned"
  , "short"
  , "long"
];

const kwObject = keywords.reduce((obj, w) => {
  obj[w] = w;
  return obj;
}, {});

const moo = __webpack_require__(694);
// Terminal tokens are in all caps
const lexer = moo.compile({
  SPACE: {match: /\s+/, lineBreaks: true},
  DECIMALEXP: /(?:(?:\d+\.\d*)|(?:\d*\.\d+)|(?:[0-9]+))[eE](?:[+|-])?[0-9]+/,
  DECIMAL: /(?:(?:\d+\.\d*)|(?:\d*\.\d+))/,
  INTEGER: /0[xX][0-9a-fA-F]+|\d+/,
  COMMENT: /(?:\/\/[^\n]*)|(?:\/\*(?:.|\n)+?\*\/)/,
  STRING: {match: /"(?:\\["\\rnu]|[^"\\])*"/, value: x => x.slice(1, -1)}, // remove outside quotes
  LCBR: '{',
  RCBR: '}',
  LBR: '[',
  RBR: ']',
  LT: '<',
  GT: '>',
  LPAR: '(',
  RPAR: ')',
  ':': ':',
  ';': ';',
  ',': ',',
  AT: '@',
  PND: '#',
  PT: ".",
  '/': "/",
  SIGN: /[+-]/,
  EQ: /=[^\n]*?/,
  NAME: {match: /[a-zA-Z_][a-zA-Z0-9_]*(?:\:\:[a-zA-Z][a-zA-Z0-9_]*)*/, type: moo.keywords(kwObject)},
});

// Ignore whitespace and comment tokens
const tokensToIgnore = ['SPACE', 'COMMENT'];
// requires us to override the lexer's next function
lexer.next = (next => () => {
  let token;
  while ((token = next.call(lexer)) && tokensToIgnore.includes(token.type)) {}
  return token;
})(lexer.next);

/*** Utility functions ******/

// also used to parse tokens to strings since they start as an object
function join(d){
  return d.join("");
}

// used for combining AST components
function extend(objs) {
  return objs.filter(Boolean).reduce((r, p) => ({ ...r, ...p }), {});
}

function noop() {
  return null;
}

function getIntOrConstantValue(d) {
  const int = parseInt(d);
  if(!isNaN(int)) {
    return int;
  }

  // handle %NAME token
  return d?.value ? {usesConstant: true, name: d.value} : undefined;
}

var grammar = {
    Lexer: lexer,
    ParserRules: [
    {"name": "main$ebnf$1$subexpression$1$ebnf$1", "symbols": []},
    {"name": "main$ebnf$1$subexpression$1$ebnf$1", "symbols": ["main$ebnf$1$subexpression$1$ebnf$1", "importDcl"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "main$ebnf$1$subexpression$1", "symbols": ["main$ebnf$1$subexpression$1$ebnf$1", "definition"]},
    {"name": "main$ebnf$1", "symbols": ["main$ebnf$1$subexpression$1"]},
    {"name": "main$ebnf$1$subexpression$2$ebnf$1", "symbols": []},
    {"name": "main$ebnf$1$subexpression$2$ebnf$1", "symbols": ["main$ebnf$1$subexpression$2$ebnf$1", "importDcl"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "main$ebnf$1$subexpression$2", "symbols": ["main$ebnf$1$subexpression$2$ebnf$1", "definition"]},
    {"name": "main$ebnf$1", "symbols": ["main$ebnf$1", "main$ebnf$1$subexpression$2"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "main", "symbols": ["main$ebnf$1"], "postprocess":  d => {
          return d[0].flatMap(inner => inner[1]);
        }
        },
    {"name": "importDcl$subexpression$1", "symbols": [(lexer.has("STRING") ? {type: "STRING"} : STRING)]},
    {"name": "importDcl$subexpression$1$ebnf$1", "symbols": []},
    {"name": "importDcl$subexpression$1$ebnf$1$subexpression$1", "symbols": [{"literal":"/"}, (lexer.has("NAME") ? {type: "NAME"} : NAME)]},
    {"name": "importDcl$subexpression$1$ebnf$1", "symbols": ["importDcl$subexpression$1$ebnf$1", "importDcl$subexpression$1$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "importDcl$subexpression$1", "symbols": [{"literal":"<"}, (lexer.has("NAME") ? {type: "NAME"} : NAME), "importDcl$subexpression$1$ebnf$1", {"literal":"."}, {"literal":"idl"}, {"literal":">"}]},
    {"name": "importDcl", "symbols": [{"literal":"#"}, {"literal":"include"}, "importDcl$subexpression$1"], "postprocess": noop},
    {"name": "moduleDcl$ebnf$1$subexpression$1", "symbols": ["definition"]},
    {"name": "moduleDcl$ebnf$1", "symbols": ["moduleDcl$ebnf$1$subexpression$1"]},
    {"name": "moduleDcl$ebnf$1$subexpression$2", "symbols": ["definition"]},
    {"name": "moduleDcl$ebnf$1", "symbols": ["moduleDcl$ebnf$1", "moduleDcl$ebnf$1$subexpression$2"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "moduleDcl", "symbols": [{"literal":"module"}, "fieldName", {"literal":"{"}, "moduleDcl$ebnf$1", {"literal":"}"}], "postprocess": 
        function processModule(d) {
          const moduleName = d[1].name;
          const defs = d[3];
          // need to return array here to keep same signature as processComplexModule
          return {
            declarator: "module",
            name: moduleName,
            definitions: defs.flat(1),
          };
        }
        },
    {"name": "definition$subexpression$1", "symbols": ["typeDcl"]},
    {"name": "definition$subexpression$1", "symbols": ["constantDcl"]},
    {"name": "definition$subexpression$1", "symbols": ["moduleDcl"]},
    {"name": "definition$subexpression$1", "symbols": ["union"]},
    {"name": "definition", "symbols": ["multiAnnotations", "definition$subexpression$1", "semi"], "postprocess":  d => {
          const annotations = d[0];
          const declaration = d[1][0];
          return extend([annotations, declaration]);
        }},
    {"name": "typeDcl$subexpression$1", "symbols": ["struct"]},
    {"name": "typeDcl$subexpression$1", "symbols": ["typedef"]},
    {"name": "typeDcl$subexpression$1", "symbols": ["enum"]},
    {"name": "typeDcl", "symbols": ["typeDcl$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "union", "symbols": [{"literal":"union"}, "fieldName", {"literal":"switch"}, {"literal":"("}, "switchTypedef", {"literal":")"}, {"literal":"{"}, "switchBody", {"literal":"}"}], "postprocess": 
        (d) => {
        const name = d[1].name
        const switchType = d[4].type;
        const switchBody = d[7];
        const allCases = switchBody;
        const defaultCase = allCases.find(c => "default" in c);
        const cases = allCases.filter(c => ("predicates" in c));
        const unionNode = {
          declarator: "union",
          name,
          switchType,
          cases,
        };
        if(defaultCase) {
          unionNode.defaultCase = defaultCase.default;
        }
        return unionNode;
        }
        },
    {"name": "switchTypedef$subexpression$1", "symbols": ["customType"]},
    {"name": "switchTypedef$subexpression$1", "symbols": ["numericType"]},
    {"name": "switchTypedef$subexpression$1", "symbols": ["booleanType"]},
    {"name": "switchTypedef", "symbols": ["switchTypedef$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "switchBody$ebnf$1", "symbols": ["case"]},
    {"name": "switchBody$ebnf$1", "symbols": ["switchBody$ebnf$1", "case"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "switchBody", "symbols": ["switchBody$ebnf$1"], "postprocess": d => d.flat(2)},
    {"name": "case$ebnf$1", "symbols": ["caseLabel"]},
    {"name": "case$ebnf$1", "symbols": ["case$ebnf$1", "caseLabel"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "case", "symbols": ["case$ebnf$1", "elementSpec", {"literal":";"}], "postprocess":  d => {
          const cases = d[0];
          const type = d[1]
          const nonDefaultCases = cases.filter(casePredicate => casePredicate !== "default");
          const isDefault = cases.length !== nonDefaultCases.length;
          const caseArray = []
          if(isDefault) {
            caseArray.push({default: type});
          }
          if(nonDefaultCases.length > 0) {
            caseArray.push({
              predicates: nonDefaultCases,
              type,
            });
          }
          return caseArray;
        }},
    {"name": "caseLabel$subexpression$1", "symbols": [{"literal":"case"}, "constExpression", {"literal":":"}]},
    {"name": "caseLabel", "symbols": ["caseLabel$subexpression$1"], "postprocess": (d) => d[0][1]},
    {"name": "caseLabel$subexpression$2", "symbols": [{"literal":"default"}, {"literal":":"}]},
    {"name": "caseLabel", "symbols": ["caseLabel$subexpression$2"], "postprocess": () => "default"},
    {"name": "elementSpec", "symbols": ["typeDeclaratorWithAnnotations"], "postprocess": d => d[0]},
    {"name": "enum$ebnf$1", "symbols": []},
    {"name": "enum$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "enumFieldName"]},
    {"name": "enum$ebnf$1", "symbols": ["enum$ebnf$1", "enum$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "enum", "symbols": [{"literal":"enum"}, "fieldName", {"literal":"{"}, "enumFieldName", "enum$ebnf$1", {"literal":"}"}], "postprocess":  d => {
          const name = d[1].name;
          const firstMember = d[3];
          const members = d[4]
            .flat(2)
            // need to filter out commas
            .filter(item => Boolean(item) && item.type !== ",");
        
          return {
            declarator: 'enum',
            name,
            enumerators: [firstMember, ...members],
          };
        } },
    {"name": "enumFieldName", "symbols": ["multiAnnotations", "fieldName"], "postprocess":  d => {
          const annotations = d[0];
          const name = d[1];
          return extend([annotations, name]);
        } },
    {"name": "struct$ebnf$1", "symbols": []},
    {"name": "struct$ebnf$1$subexpression$1", "symbols": ["member"]},
    {"name": "struct$ebnf$1", "symbols": ["struct$ebnf$1", "struct$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "struct", "symbols": [{"literal":"struct"}, "fieldName", {"literal":"{"}, "struct$ebnf$1", {"literal":"}"}], "postprocess":  d => {
          const name = d[1].name;
          const definitions = d[3].flat(2).filter(def => def !== null);
          return {
            declarator: 'struct',
            name,
            definitions,
          };
        } },
    {"name": "typedef", "symbols": [{"literal":"typedef"}, "typeDeclarator"], "postprocess":  ([_, definition]) => (
          { declarator: "typedef", ...definition }
        )},
    {"name": "typeDeclaratorWithAnnotations", "symbols": ["multiAnnotations", "typeDeclarator"], "postprocess":  d => {
          const annotations = d[0];
          const definition = d[1];
          return extend([annotations, definition]);
        } },
    {"name": "typeDeclarator$subexpression$1", "symbols": ["allTypes", "fieldName", "arrayLengths"]},
    {"name": "typeDeclarator$subexpression$1", "symbols": ["allTypes", "fieldName"]},
    {"name": "typeDeclarator$subexpression$1", "symbols": ["sequenceType", "fieldName"]},
    {"name": "typeDeclarator", "symbols": ["typeDeclarator$subexpression$1"], "postprocess": d => extend(d[0])},
    {"name": "constantDcl", "symbols": ["constType"], "postprocess": d => d[0]},
    {"name": "member", "symbols": ["fieldWithAnnotation", "semi"], "postprocess": d => d[0]},
    {"name": "fieldWithAnnotation", "symbols": ["multiAnnotations", "fieldDcl"], "postprocess":  d=> {
          
          const annotations = d[0]
          const fields = d[1];
          const finalDefs = fields.map((def) =>
            extend([annotations, def])
          );
          return finalDefs;
        } },
    {"name": "fieldDcl$subexpression$1", "symbols": ["allTypes", "multiFieldNames", "arrayLengths"]},
    {"name": "fieldDcl$subexpression$1", "symbols": ["allTypes", "multiFieldNames"]},
    {"name": "fieldDcl$subexpression$1", "symbols": ["sequenceType", "multiFieldNames"]},
    {"name": "fieldDcl", "symbols": ["fieldDcl$subexpression$1"], "postprocess":  (d) => {
          const names = d[0].splice(1, 1)[0];
          // create a definition for each name
          const defs = names.map((nameObj) => ({
            ...extend([...d[0], nameObj]),
            declarator: "struct-member"
          }));
          return defs;
        } },
    {"name": "multiFieldNames$ebnf$1", "symbols": []},
    {"name": "multiFieldNames$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "fieldName"]},
    {"name": "multiFieldNames$ebnf$1", "symbols": ["multiFieldNames$ebnf$1", "multiFieldNames$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "multiFieldNames", "symbols": ["fieldName", "multiFieldNames$ebnf$1"], "postprocess": 
        d => {
          const fieldNames = d.flat(2).filter( d => d !== null && d.name);
          return fieldNames;
        } },
    {"name": "multiAnnotations$ebnf$1", "symbols": []},
    {"name": "multiAnnotations$ebnf$1", "symbols": ["multiAnnotations$ebnf$1", "annotation"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "multiAnnotations", "symbols": ["multiAnnotations$ebnf$1"], "postprocess": 
        d => {
          return d[0].length > 0 ? {annotations: d[0].reduce((record, annotation) => {
            record[annotation.name] = annotation;
            return record;
          }, {}) } : null;
        }
        },
    {"name": "annotation$ebnf$1$subexpression$1", "symbols": [{"literal":"("}, "annotationParams", {"literal":")"}]},
    {"name": "annotation$ebnf$1", "symbols": ["annotation$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "annotation$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "annotation", "symbols": ["at", (lexer.has("NAME") ? {type: "NAME"} : NAME), "annotation$ebnf$1"], "postprocess":  d => {
          const annotationName = d[1].value;
          const params = d[2] ? d[2][1] : undefined;
          if(params == undefined) {
            return { type: 'no-params', name: annotationName };
          }
          // named params in the form of [{<name>: <value>}, ...]
          if(Array.isArray(params)) {
            const namedParamsRecord = extend(params);
            return {
              type: 'named-params',
              name: annotationName,
              namedParams: namedParamsRecord
            };
          }
        
          // can only be constant param
          return { type: "const-param", value: params, name: annotationName };
        } },
    {"name": "annotationParams$subexpression$1", "symbols": ["multipleNamedAnnotationParams"]},
    {"name": "annotationParams$subexpression$1", "symbols": ["constExpression"]},
    {"name": "annotationParams", "symbols": ["annotationParams$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "multipleNamedAnnotationParams$ebnf$1", "symbols": []},
    {"name": "multipleNamedAnnotationParams$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "namedAnnotationParam"]},
    {"name": "multipleNamedAnnotationParams$ebnf$1", "symbols": ["multipleNamedAnnotationParams$ebnf$1", "multipleNamedAnnotationParams$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "multipleNamedAnnotationParams", "symbols": ["namedAnnotationParam", "multipleNamedAnnotationParams$ebnf$1"], "postprocess": 
        d => ([d[0], ...d[1].flatMap(([, param]) => param)]) // returns array
        },
    {"name": "constExpression", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)], "postprocess":  d => 
        // should match `variableAssignment` constant usage structure for consistency
        // between named and const annotation types
        ({usesConstant: true, name: d[0].value})
        },
    {"name": "constExpression", "symbols": ["literal"], "postprocess": d => d[0].value},
    {"name": "namedAnnotationParam$subexpression$1", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME), "assignment"]},
    {"name": "namedAnnotationParam", "symbols": ["namedAnnotationParam$subexpression$1"], "postprocess": d => ({[d[0][0].value]: d[0][1].value})},
    {"name": "at", "symbols": [{"literal":"@"}], "postprocess": noop},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "numericType", "fieldName", "floatAssignment", "simple"]},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "numericType", "fieldName", "intAssignment", "simple"]},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "stringType", "fieldName", "stringAssignment", "simple"]},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "booleanType", "fieldName", "booleanAssignment", "simple"]},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "customType", "fieldName", "variableAssignment", "simple"]},
    {"name": "constType", "symbols": ["constType$subexpression$1"], "postprocess":  d => {
          return extend(d[0]);
        } },
    {"name": "constKeyword", "symbols": [{"literal":"const"}], "postprocess": d => ({isConstant: true, declarator: "const"})},
    {"name": "fieldName", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)], "postprocess": d => ({name: d[0].value})},
    {"name": "sequenceType$ebnf$1$subexpression$1$subexpression$1", "symbols": ["INT"]},
    {"name": "sequenceType$ebnf$1$subexpression$1$subexpression$1", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)]},
    {"name": "sequenceType$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "sequenceType$ebnf$1$subexpression$1$subexpression$1"]},
    {"name": "sequenceType$ebnf$1", "symbols": ["sequenceType$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "sequenceType$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "sequenceType", "symbols": [{"literal":"sequence"}, {"literal":"<"}, "allTypes", "sequenceType$ebnf$1", {"literal":">"}], "postprocess":  d => {
          const arrayUpperBound = d[3] !== null ? getIntOrConstantValue(d[3][1][0]) : undefined;
          const typeObj = d[2];
          return {
            ...typeObj,
            isArray: true,
            arrayUpperBound,
          };
        }},
    {"name": "arrayLengths$ebnf$1", "symbols": ["arrayLength"]},
    {"name": "arrayLengths$ebnf$1", "symbols": ["arrayLengths$ebnf$1", "arrayLength"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "arrayLengths", "symbols": ["arrayLengths$ebnf$1"], "postprocess": 
        (d) => {
          const arrInfo = {isArray: true};
          const arrLengthList = d.flat(2).filter((num) => num != undefined);
          arrInfo.arrayLengths = arrLengthList;
          return arrInfo;
        }
        },
    {"name": "arrayLength$subexpression$1", "symbols": ["INT"]},
    {"name": "arrayLength$subexpression$1", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)]},
    {"name": "arrayLength", "symbols": [{"literal":"["}, "arrayLength$subexpression$1", {"literal":"]"}], "postprocess": 
        ([, intOrName]) => (getIntOrConstantValue(intOrName ? intOrName[0] : undefined))
        },
    {"name": "assignment$subexpression$1", "symbols": ["floatAssignment"]},
    {"name": "assignment$subexpression$1", "symbols": ["intAssignment"]},
    {"name": "assignment$subexpression$1", "symbols": ["stringAssignment"]},
    {"name": "assignment$subexpression$1", "symbols": ["booleanAssignment"]},
    {"name": "assignment$subexpression$1", "symbols": ["variableAssignment"]},
    {"name": "assignment", "symbols": ["assignment$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "floatAssignment$subexpression$1", "symbols": ["SIGNED_FLOAT"]},
    {"name": "floatAssignment$subexpression$1", "symbols": ["FLOAT"]},
    {"name": "floatAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), "floatAssignment$subexpression$1"], "postprocess": ([, num]) => ({valueText: num[0], value: parseFloat(num[0])})},
    {"name": "intAssignment$subexpression$1", "symbols": ["SIGNED_INT"]},
    {"name": "intAssignment$subexpression$1", "symbols": ["INT"]},
    {"name": "intAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), "intAssignment$subexpression$1"], "postprocess": ([, num]) => ({valueText: num[0], value: parseInt(num[0])})},
    {"name": "stringAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), "STR"], "postprocess": ([, str]) => ({valueText: str, value: str})},
    {"name": "booleanAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), "BOOLEAN"], "postprocess": ([, bool]) => ({valueText: bool, value: bool === "TRUE"})},
    {"name": "variableAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), (lexer.has("NAME") ? {type: "NAME"} : NAME)], "postprocess":  ([, name]) => 
        ({
          valueText: name.value,
          value: {
            usesConstant: true,
            name: name.value
          }
        })
        },
    {"name": "allTypes$subexpression$1", "symbols": ["primitiveTypes"]},
    {"name": "allTypes$subexpression$1", "symbols": ["customType"]},
    {"name": "allTypes", "symbols": ["allTypes$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "primitiveTypes$subexpression$1", "symbols": ["stringType"]},
    {"name": "primitiveTypes$subexpression$1", "symbols": ["numericType"]},
    {"name": "primitiveTypes$subexpression$1", "symbols": ["booleanType"]},
    {"name": "primitiveTypes", "symbols": ["primitiveTypes$subexpression$1"], "postprocess": d => ({...d[0][0], isComplex: false})},
    {"name": "customType", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)], "postprocess":  d => {
          const typeName = d[0].value;
        
          // post process will go through and replace typedefs with their actual type
          return {type: typeName };
        }},
    {"name": "stringType$subexpression$1", "symbols": [{"literal":"string"}]},
    {"name": "stringType$subexpression$1", "symbols": [{"literal":"wstring"}]},
    {"name": "stringType$ebnf$1$subexpression$1$subexpression$1", "symbols": ["INT"]},
    {"name": "stringType$ebnf$1$subexpression$1$subexpression$1", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)]},
    {"name": "stringType$ebnf$1$subexpression$1", "symbols": [{"literal":"<"}, "stringType$ebnf$1$subexpression$1$subexpression$1", {"literal":">"}]},
    {"name": "stringType$ebnf$1", "symbols": ["stringType$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "stringType$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "stringType", "symbols": ["stringType$subexpression$1", "stringType$ebnf$1"], "postprocess":  d => {
          const stringKind = d[0][0].value;
          let strLength = undefined;
          if(d[1] !== null) {
            strLength = getIntOrConstantValue(d[1][1] ? d[1][1][0] : undefined);
          }
          return {type: stringKind, upperBound: strLength};
        } },
    {"name": "booleanType", "symbols": [{"literal":"boolean"}], "postprocess": d => ({type: "bool"})},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"byte"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"octet"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"wchar"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"char"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"long"}, {"literal":"double"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"double"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"float"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int8"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint8"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int16"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint16"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int32"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint32"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int64"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint64"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"unsigned"}, {"literal":"short"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"short"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"unsigned"}, {"literal":"long"}, {"literal":"long"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"long"}, {"literal":"long"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"unsigned"}, {"literal":"long"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"long"}]},
    {"name": "numericType", "symbols": ["numericType$subexpression$1"], "postprocess":  (d) => {
          const typeString = d[0].map((t) => t?.value).filter(t => !!t).join(" ");
          return { type: typeString };
        }
        },
    {"name": "literal$subexpression$1", "symbols": ["booleanLiteral"]},
    {"name": "literal$subexpression$1", "symbols": ["strLiteral"]},
    {"name": "literal$subexpression$1", "symbols": ["floatLiteral"]},
    {"name": "literal$subexpression$1", "symbols": ["intLiteral"]},
    {"name": "literal", "symbols": ["literal$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "booleanLiteral", "symbols": ["BOOLEAN"], "postprocess": d => ({value: d[0] === "TRUE"})},
    {"name": "strLiteral", "symbols": ["STR"], "postprocess": d => ({value: d[0]})},
    {"name": "floatLiteral$subexpression$1", "symbols": ["SIGNED_FLOAT"]},
    {"name": "floatLiteral$subexpression$1", "symbols": ["FLOAT"]},
    {"name": "floatLiteral", "symbols": ["floatLiteral$subexpression$1"], "postprocess": d => ({value: parseFloat(d[0][0])})},
    {"name": "intLiteral$subexpression$1", "symbols": ["SIGNED_INT"]},
    {"name": "intLiteral$subexpression$1", "symbols": ["INT"]},
    {"name": "intLiteral", "symbols": ["intLiteral$subexpression$1"], "postprocess": d => ({value: parseInt(d[0][0])})},
    {"name": "BOOLEAN$subexpression$1", "symbols": [{"literal":"TRUE"}]},
    {"name": "BOOLEAN$subexpression$1", "symbols": [{"literal":"FALSE"}]},
    {"name": "BOOLEAN", "symbols": ["BOOLEAN$subexpression$1"], "postprocess": join},
    {"name": "STR$ebnf$1", "symbols": [(lexer.has("STRING") ? {type: "STRING"} : STRING)]},
    {"name": "STR$ebnf$1", "symbols": ["STR$ebnf$1", (lexer.has("STRING") ? {type: "STRING"} : STRING)], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "STR", "symbols": ["STR$ebnf$1"], "postprocess":  d => {
          return join(d.flat(1).filter(d => d !== null));
        }},
    {"name": "SIGNED_FLOAT$subexpression$1", "symbols": [{"literal":"+"}]},
    {"name": "SIGNED_FLOAT$subexpression$1", "symbols": [{"literal":"-"}]},
    {"name": "SIGNED_FLOAT", "symbols": ["SIGNED_FLOAT$subexpression$1", "FLOAT"], "postprocess": join},
    {"name": "FLOAT$subexpression$1", "symbols": [(lexer.has("DECIMAL") ? {type: "DECIMAL"} : DECIMAL)]},
    {"name": "FLOAT$subexpression$1", "symbols": [(lexer.has("DECIMALEXP") ? {type: "DECIMALEXP"} : DECIMALEXP)]},
    {"name": "FLOAT", "symbols": ["FLOAT$subexpression$1"], "postprocess": join},
    {"name": "FLOAT$subexpression$2", "symbols": [(lexer.has("DECIMAL") ? {type: "DECIMAL"} : DECIMAL), {"literal":"d"}]},
    {"name": "FLOAT", "symbols": ["FLOAT$subexpression$2"], "postprocess": d => d[0][0].value},
    {"name": "FLOAT$subexpression$3", "symbols": ["INT", {"literal":"d"}]},
    {"name": "FLOAT", "symbols": ["FLOAT$subexpression$3"], "postprocess": d => d[0][0]},
    {"name": "SIGNED_INT$subexpression$1", "symbols": [{"literal":"+"}]},
    {"name": "SIGNED_INT$subexpression$1", "symbols": [{"literal":"-"}]},
    {"name": "SIGNED_INT", "symbols": ["SIGNED_INT$subexpression$1", "INT"], "postprocess": join},
    {"name": "INT", "symbols": [(lexer.has("INTEGER") ? {type: "INTEGER"} : INTEGER)], "postprocess": join},
    {"name": "semi", "symbols": [{"literal":";"}], "postprocess": noop},
    {"name": "simple", "symbols": [], "postprocess": () => ({isComplex: false})}
]
  , ParserStart: "main"
}
if ( true&& typeof module.exports !== 'undefined') {
   module.exports = grammar;
} else {
   window.grammar = grammar;
}
})();


/***/ }),

/***/ 522:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UnionIDLNode = void 0;
const IDLNode_1 = __webpack_require__(165);
const StructMemberIDLNode_1 = __webpack_require__(572);
const primitiveTypes_1 = __webpack_require__(731);
class UnionIDLNode extends IDLNode_1.IDLNode {
    switchTypeNeedsResolution = false;
    constructor(scopePath, astNode, idlMap) {
        super(scopePath, astNode, idlMap);
        if (!primitiveTypes_1.SIMPLE_TYPES.has(this.astNode.switchType)) {
            this.switchTypeNeedsResolution = true;
        }
    }
    get type() {
        return this.astNode.name;
    }
    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    get isComplex() {
        return true;
    }
    _switchTypeNode;
    switchTypeNode() {
        if (this._switchTypeNode) {
            return this._switchTypeNode;
        }
        const typeNode = this.getNode(this.scopePath, this.astNode.switchType);
        if (typeNode.declarator !== "enum" && typeNode.declarator !== "typedef") {
            throw new Error(`Invalid switch type "${typeNode.scopedIdentifier}" ${this.astNode.switchType} in ${this.scopedIdentifier}`);
        }
        this._switchTypeNode = typeNode;
        return typeNode;
    }
    get switchType() {
        let switchType = this.astNode.switchType;
        if (this.switchTypeNeedsResolution) {
            switchType = this.switchTypeNode().type;
        }
        if (!isValidSwitchType(switchType)) {
            throw new Error(`Invalid resolved switch type ${switchType} in ${this.scopedIdentifier}`);
        }
        return switchType;
    }
    get cases() {
        // If the switch type is an enum that means the case predicate values can be just the enumerator name
        // So we need to search the scope of the enum for the enumerator and get its value
        const isEnumSwitchType = this.switchTypeNeedsResolution && this.switchTypeNode().declarator === "enum";
        const predicateScopePath = isEnumSwitchType
            ? this.switchTypeNode().scopedIdentifier.split("::")
            : this.scopePath;
        return this.astNode.cases.map((def) => {
            // These are not referenced anywhere so not necessary having in the map
            const typeNode = new StructMemberIDLNode_1.StructMemberIDLNode([...this.scopePath, this.name], { ...def.type, declarator: "struct-member" }, // unfortunate shoehorning for struct-member node
            this.map);
            const resolvedPredicates = def.predicates.map((predicate) => {
                if (typeof predicate === "object") {
                    return this.getConstantNode(predicate.name, predicateScopePath).value;
                }
                return predicate;
            });
            const resolvedType = typeNode.toIDLMessageDefinitionField();
            return {
                type: resolvedType,
                predicates: resolvedPredicates,
            };
        });
    }
    get defaultCase() {
        if (!this.astNode.defaultCase) {
            return undefined;
        }
        const typeNode = new StructMemberIDLNode_1.StructMemberIDLNode([...this.scopePath, this.name], { ...this.astNode.defaultCase, declarator: "struct-member" }, // unfortunate shoehorning for struct-member node
        this.map);
        return typeNode.toIDLMessageDefinitionField();
    }
    toIDLMessageDefinition() {
        const annotations = this.annotations;
        return {
            name: this.scopedIdentifier,
            switchType: (0, primitiveTypes_1.normalizeType)(this.switchType),
            cases: this.cases,
            aggregatedKind: "union",
            ...(this.astNode.defaultCase ? { defaultCase: this.defaultCase } : undefined),
            ...(annotations ? { annotations } : undefined),
        };
    }
}
exports.UnionIDLNode = UnionIDLNode;
function isValidSwitchType(type) {
    return primitiveTypes_1.INTEGER_TYPES.has(type) || type === "bool";
}


/***/ }),

/***/ 572:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StructMemberIDLNode = void 0;
const ReferenceTypeIDLNode_1 = __webpack_require__(852);
const primitiveTypes_1 = __webpack_require__(731);
class StructMemberIDLNode extends ReferenceTypeIDLNode_1.ReferenceTypeIDLNode {
    /** Writes out ASTNode as a fully resolved IDL message definition */
    toIDLMessageDefinitionField() {
        const msgDefinitionField = {
            name: this.name,
            type: (0, primitiveTypes_1.normalizeType)(this.type),
            isComplex: this.isComplex,
        };
        if (this.arrayLengths != undefined) {
            // NOTE: if arrayLengths is undefined that means it is an IDL Sequence
            // which affects deserialization
            msgDefinitionField.arrayLengths = this.arrayLengths;
        }
        if (this.arrayUpperBound != undefined) {
            msgDefinitionField.arrayUpperBound = this.arrayUpperBound;
        }
        if (this.upperBound != undefined) {
            msgDefinitionField.upperBound = this.upperBound;
        }
        if (this.annotations != undefined) {
            msgDefinitionField.annotations = this.annotations;
        }
        if (this.isArray != undefined) {
            msgDefinitionField.isArray = this.isArray;
        }
        if (this.enumType != undefined) {
            msgDefinitionField.enumType = this.enumType;
        }
        const maybeDefault = this.annotations?.default;
        if (maybeDefault && maybeDefault.type !== "no-params") {
            const defaultValue = maybeDefault.type === "const-param" ? maybeDefault.value : maybeDefault.namedParams.value;
            if (typeof defaultValue !== "object") {
                msgDefinitionField.defaultValue = defaultValue;
            }
            else {
                msgDefinitionField.defaultValue = this.getConstantNode(defaultValue.name).value;
            }
        }
        return msgDefinitionField;
    }
}
exports.StructMemberIDLNode = StructMemberIDLNode;


/***/ }),

/***/ 662:
/***/ (function(module) {

(function(root, factory) {
    if ( true && module.exports) {
        module.exports = factory();
    } else {
        root.nearley = factory();
    }
}(this, function() {

    function Rule(name, symbols, postprocess) {
        this.id = ++Rule.highestId;
        this.name = name;
        this.symbols = symbols;        // a list of literal | regex class | nonterminal
        this.postprocess = postprocess;
        return this;
    }
    Rule.highestId = 0;

    Rule.prototype.toString = function(withCursorAt) {
        var symbolSequence = (typeof withCursorAt === "undefined")
                             ? this.symbols.map(getSymbolShortDisplay).join(' ')
                             : (   this.symbols.slice(0, withCursorAt).map(getSymbolShortDisplay).join(' ')
                                 + " ● "
                                 + this.symbols.slice(withCursorAt).map(getSymbolShortDisplay).join(' ')     );
        return this.name + " → " + symbolSequence;
    }


    // a State is a rule at a position from a given starting point in the input stream (reference)
    function State(rule, dot, reference, wantedBy) {
        this.rule = rule;
        this.dot = dot;
        this.reference = reference;
        this.data = [];
        this.wantedBy = wantedBy;
        this.isComplete = this.dot === rule.symbols.length;
    }

    State.prototype.toString = function() {
        return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
    };

    State.prototype.nextState = function(child) {
        var state = new State(this.rule, this.dot + 1, this.reference, this.wantedBy);
        state.left = this;
        state.right = child;
        if (state.isComplete) {
            state.data = state.build();
            // Having right set here will prevent the right state and its children
            // form being garbage collected
            state.right = undefined;
        }
        return state;
    };

    State.prototype.build = function() {
        var children = [];
        var node = this;
        do {
            children.push(node.right.data);
            node = node.left;
        } while (node.left);
        children.reverse();
        return children;
    };

    State.prototype.finish = function() {
        if (this.rule.postprocess) {
            this.data = this.rule.postprocess(this.data, this.reference, Parser.fail);
        }
    };


    function Column(grammar, index) {
        this.grammar = grammar;
        this.index = index;
        this.states = [];
        this.wants = {}; // states indexed by the non-terminal they expect
        this.scannable = []; // list of states that expect a token
        this.completed = {}; // states that are nullable
    }


    Column.prototype.process = function(nextColumn) {
        var states = this.states;
        var wants = this.wants;
        var completed = this.completed;

        for (var w = 0; w < states.length; w++) { // nb. we push() during iteration
            var state = states[w];

            if (state.isComplete) {
                state.finish();
                if (state.data !== Parser.fail) {
                    // complete
                    var wantedBy = state.wantedBy;
                    for (var i = wantedBy.length; i--; ) { // this line is hot
                        var left = wantedBy[i];
                        this.complete(left, state);
                    }

                    // special-case nullables
                    if (state.reference === this.index) {
                        // make sure future predictors of this rule get completed.
                        var exp = state.rule.name;
                        (this.completed[exp] = this.completed[exp] || []).push(state);
                    }
                }

            } else {
                // queue scannable states
                var exp = state.rule.symbols[state.dot];
                if (typeof exp !== 'string') {
                    this.scannable.push(state);
                    continue;
                }

                // predict
                if (wants[exp]) {
                    wants[exp].push(state);

                    if (completed.hasOwnProperty(exp)) {
                        var nulls = completed[exp];
                        for (var i = 0; i < nulls.length; i++) {
                            var right = nulls[i];
                            this.complete(state, right);
                        }
                    }
                } else {
                    wants[exp] = [state];
                    this.predict(exp);
                }
            }
        }
    }

    Column.prototype.predict = function(exp) {
        var rules = this.grammar.byName[exp] || [];

        for (var i = 0; i < rules.length; i++) {
            var r = rules[i];
            var wantedBy = this.wants[exp];
            var s = new State(r, 0, this.index, wantedBy);
            this.states.push(s);
        }
    }

    Column.prototype.complete = function(left, right) {
        var copy = left.nextState(right);
        this.states.push(copy);
    }


    function Grammar(rules, start) {
        this.rules = rules;
        this.start = start || this.rules[0].name;
        var byName = this.byName = {};
        this.rules.forEach(function(rule) {
            if (!byName.hasOwnProperty(rule.name)) {
                byName[rule.name] = [];
            }
            byName[rule.name].push(rule);
        });
    }

    // So we can allow passing (rules, start) directly to Parser for backwards compatibility
    Grammar.fromCompiled = function(rules, start) {
        var lexer = rules.Lexer;
        if (rules.ParserStart) {
          start = rules.ParserStart;
          rules = rules.ParserRules;
        }
        var rules = rules.map(function (r) { return (new Rule(r.name, r.symbols, r.postprocess)); });
        var g = new Grammar(rules, start);
        g.lexer = lexer; // nb. storing lexer on Grammar is iffy, but unavoidable
        return g;
    }


    function StreamLexer() {
      this.reset("");
    }

    StreamLexer.prototype.reset = function(data, state) {
        this.buffer = data;
        this.index = 0;
        this.line = state ? state.line : 1;
        this.lastLineBreak = state ? -state.col : 0;
    }

    StreamLexer.prototype.next = function() {
        if (this.index < this.buffer.length) {
            var ch = this.buffer[this.index++];
            if (ch === '\n') {
              this.line += 1;
              this.lastLineBreak = this.index;
            }
            return {value: ch};
        }
    }

    StreamLexer.prototype.save = function() {
      return {
        line: this.line,
        col: this.index - this.lastLineBreak,
      }
    }

    StreamLexer.prototype.formatError = function(token, message) {
        // nb. this gets called after consuming the offending token,
        // so the culprit is index-1
        var buffer = this.buffer;
        if (typeof buffer === 'string') {
            var lines = buffer
                .split("\n")
                .slice(
                    Math.max(0, this.line - 5), 
                    this.line
                );

            var nextLineBreak = buffer.indexOf('\n', this.index);
            if (nextLineBreak === -1) nextLineBreak = buffer.length;
            var col = this.index - this.lastLineBreak;
            var lastLineDigits = String(this.line).length;
            message += " at line " + this.line + " col " + col + ":\n\n";
            message += lines
                .map(function(line, i) {
                    return pad(this.line - lines.length + i + 1, lastLineDigits) + " " + line;
                }, this)
                .join("\n");
            message += "\n" + pad("", lastLineDigits + col) + "^\n";
            return message;
        } else {
            return message + " at index " + (this.index - 1);
        }

        function pad(n, length) {
            var s = String(n);
            return Array(length - s.length + 1).join(" ") + s;
        }
    }

    function Parser(rules, start, options) {
        if (rules instanceof Grammar) {
            var grammar = rules;
            var options = start;
        } else {
            var grammar = Grammar.fromCompiled(rules, start);
        }
        this.grammar = grammar;

        // Read options
        this.options = {
            keepHistory: false,
            lexer: grammar.lexer || new StreamLexer,
        };
        for (var key in (options || {})) {
            this.options[key] = options[key];
        }

        // Setup lexer
        this.lexer = this.options.lexer;
        this.lexerState = undefined;

        // Setup a table
        var column = new Column(grammar, 0);
        var table = this.table = [column];

        // I could be expecting anything.
        column.wants[grammar.start] = [];
        column.predict(grammar.start);
        // TODO what if start rule is nullable?
        column.process();
        this.current = 0; // token index
    }

    // create a reserved token for indicating a parse fail
    Parser.fail = {};

    Parser.prototype.feed = function(chunk) {
        var lexer = this.lexer;
        lexer.reset(chunk, this.lexerState);

        var token;
        while (true) {
            try {
                token = lexer.next();
                if (!token) {
                    break;
                }
            } catch (e) {
                // Create the next column so that the error reporter
                // can display the correctly predicted states.
                var nextColumn = new Column(this.grammar, this.current + 1);
                this.table.push(nextColumn);
                var err = new Error(this.reportLexerError(e));
                err.offset = this.current;
                err.token = e.token;
                throw err;
            }
            // We add new states to table[current+1]
            var column = this.table[this.current];

            // GC unused states
            if (!this.options.keepHistory) {
                delete this.table[this.current - 1];
            }

            var n = this.current + 1;
            var nextColumn = new Column(this.grammar, n);
            this.table.push(nextColumn);

            // Advance all tokens that expect the symbol
            var literal = token.text !== undefined ? token.text : token.value;
            var value = lexer.constructor === StreamLexer ? token.value : token;
            var scannable = column.scannable;
            for (var w = scannable.length; w--; ) {
                var state = scannable[w];
                var expect = state.rule.symbols[state.dot];
                // Try to consume the token
                // either regex or literal
                if (expect.test ? expect.test(value) :
                    expect.type ? expect.type === token.type
                                : expect.literal === literal) {
                    // Add it
                    var next = state.nextState({data: value, token: token, isToken: true, reference: n - 1});
                    nextColumn.states.push(next);
                }
            }

            // Next, for each of the rules, we either
            // (a) complete it, and try to see if the reference row expected that
            //     rule
            // (b) predict the next nonterminal it expects by adding that
            //     nonterminal's start state
            // To prevent duplication, we also keep track of rules we have already
            // added

            nextColumn.process();

            // If needed, throw an error:
            if (nextColumn.states.length === 0) {
                // No states at all! This is not good.
                var err = new Error(this.reportError(token));
                err.offset = this.current;
                err.token = token;
                throw err;
            }

            // maybe save lexer state
            if (this.options.keepHistory) {
              column.lexerState = lexer.save()
            }

            this.current++;
        }
        if (column) {
          this.lexerState = lexer.save()
        }

        // Incrementally keep track of results
        this.results = this.finish();

        // Allow chaining, for whatever it's worth
        return this;
    };

    Parser.prototype.reportLexerError = function(lexerError) {
        var tokenDisplay, lexerMessage;
        // Planning to add a token property to moo's thrown error
        // even on erroring tokens to be used in error display below
        var token = lexerError.token;
        if (token) {
            tokenDisplay = "input " + JSON.stringify(token.text[0]) + " (lexer error)";
            lexerMessage = this.lexer.formatError(token, "Syntax error");
        } else {
            tokenDisplay = "input (lexer error)";
            lexerMessage = lexerError.message;
        }
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };

    Parser.prototype.reportError = function(token) {
        var tokenDisplay = (token.type ? token.type + " token: " : "") + JSON.stringify(token.value !== undefined ? token.value : token);
        var lexerMessage = this.lexer.formatError(token, "Syntax error");
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };

    Parser.prototype.reportErrorCommon = function(lexerMessage, tokenDisplay) {
        var lines = [];
        lines.push(lexerMessage);
        var lastColumnIndex = this.table.length - 2;
        var lastColumn = this.table[lastColumnIndex];
        var expectantStates = lastColumn.states
            .filter(function(state) {
                var nextSymbol = state.rule.symbols[state.dot];
                return nextSymbol && typeof nextSymbol !== "string";
            });

        if (expectantStates.length === 0) {
            lines.push('Unexpected ' + tokenDisplay + '. I did not expect any more input. Here is the state of my parse table:\n');
            this.displayStateStack(lastColumn.states, lines);
        } else {
            lines.push('Unexpected ' + tokenDisplay + '. Instead, I was expecting to see one of the following:\n');
            // Display a "state stack" for each expectant state
            // - which shows you how this state came to be, step by step.
            // If there is more than one derivation, we only display the first one.
            var stateStacks = expectantStates
                .map(function(state) {
                    return this.buildFirstStateStack(state, []) || [state];
                }, this);
            // Display each state that is expecting a terminal symbol next.
            stateStacks.forEach(function(stateStack) {
                var state = stateStack[0];
                var nextSymbol = state.rule.symbols[state.dot];
                var symbolDisplay = this.getSymbolDisplay(nextSymbol);
                lines.push('A ' + symbolDisplay + ' based on:');
                this.displayStateStack(stateStack, lines);
            }, this);
        }
        lines.push("");
        return lines.join("\n");
    }
    
    Parser.prototype.displayStateStack = function(stateStack, lines) {
        var lastDisplay;
        var sameDisplayCount = 0;
        for (var j = 0; j < stateStack.length; j++) {
            var state = stateStack[j];
            var display = state.rule.toString(state.dot);
            if (display === lastDisplay) {
                sameDisplayCount++;
            } else {
                if (sameDisplayCount > 0) {
                    lines.push('    ^ ' + sameDisplayCount + ' more lines identical to this');
                }
                sameDisplayCount = 0;
                lines.push('    ' + display);
            }
            lastDisplay = display;
        }
    };

    Parser.prototype.getSymbolDisplay = function(symbol) {
        return getSymbolLongDisplay(symbol);
    };

    /*
    Builds a the first state stack. You can think of a state stack as the call stack
    of the recursive-descent parser which the Nearley parse algorithm simulates.
    A state stack is represented as an array of state objects. Within a
    state stack, the first item of the array will be the starting
    state, with each successive item in the array going further back into history.

    This function needs to be given a starting state and an empty array representing
    the visited states, and it returns an single state stack.

    */
    Parser.prototype.buildFirstStateStack = function(state, visited) {
        if (visited.indexOf(state) !== -1) {
            // Found cycle, return null
            // to eliminate this path from the results, because
            // we don't know how to display it meaningfully
            return null;
        }
        if (state.wantedBy.length === 0) {
            return [state];
        }
        var prevState = state.wantedBy[0];
        var childVisited = [state].concat(visited);
        var childResult = this.buildFirstStateStack(prevState, childVisited);
        if (childResult === null) {
            return null;
        }
        return [state].concat(childResult);
    };

    Parser.prototype.save = function() {
        var column = this.table[this.current];
        column.lexerState = this.lexerState;
        return column;
    };

    Parser.prototype.restore = function(column) {
        var index = column.index;
        this.current = index;
        this.table[index] = column;
        this.table.splice(index + 1);
        this.lexerState = column.lexerState;

        // Incrementally keep track of results
        this.results = this.finish();
    };

    // nb. deprecated: use save/restore instead!
    Parser.prototype.rewind = function(index) {
        if (!this.options.keepHistory) {
            throw new Error('set option `keepHistory` to enable rewinding')
        }
        // nb. recall column (table) indicies fall between token indicies.
        //        col 0   --   token 0   --   col 1
        this.restore(this.table[index]);
    };

    Parser.prototype.finish = function() {
        // Return the possible parsings
        var considerations = [];
        var start = this.grammar.start;
        var column = this.table[this.table.length - 1]
        column.states.forEach(function (t) {
            if (t.rule.name === start
                    && t.dot === t.rule.symbols.length
                    && t.reference === 0
                    && t.data !== Parser.fail) {
                considerations.push(t);
            }
        });
        return considerations.map(function(c) {return c.data; });
    };

    function getSymbolLongDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") {
            return symbol;
        } else if (type === "object") {
            if (symbol.literal) {
                return JSON.stringify(symbol.literal);
            } else if (symbol instanceof RegExp) {
                return 'character matching ' + symbol;
            } else if (symbol.type) {
                return symbol.type + ' token';
            } else if (symbol.test) {
                return 'token matching ' + String(symbol.test);
            } else {
                throw new Error('Unknown symbol type: ' + symbol);
            }
        }
    }

    function getSymbolShortDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") {
            return symbol;
        } else if (type === "object") {
            if (symbol.literal) {
                return JSON.stringify(symbol.literal);
            } else if (symbol instanceof RegExp) {
                return symbol.toString();
            } else if (symbol.type) {
                return '%' + symbol.type;
            } else if (symbol.test) {
                return '<' + String(symbol.test) + '>';
            } else {
                throw new Error('Unknown symbol type: ' + symbol);
            }
        }
    }

    return {
        Parser: Parser,
        Grammar: Grammar,
        Rule: Rule,
    };

}));


/***/ }),

/***/ 694:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) /* global define */
  } else // removed by dead control flow
{}
}(this, function() {
  'use strict';

  var hasOwnProperty = Object.prototype.hasOwnProperty
  var toString = Object.prototype.toString
  var hasSticky = typeof new RegExp().sticky === 'boolean'

  /***************************************************************************/

  function isRegExp(o) { return o && toString.call(o) === '[object RegExp]' }
  function isObject(o) { return o && typeof o === 'object' && !isRegExp(o) && !Array.isArray(o) }

  function reEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
  }
  function reGroups(s) {
    var re = new RegExp('|' + s)
    return re.exec('').length - 1
  }
  function reCapture(s) {
    return '(' + s + ')'
  }
  function reUnion(regexps) {
    if (!regexps.length) return '(?!)'
    var source =  regexps.map(function(s) {
      return "(?:" + s + ")"
    }).join('|')
    return "(?:" + source + ")"
  }

  function regexpOrLiteral(obj) {
    if (typeof obj === 'string') {
      return '(?:' + reEscape(obj) + ')'

    } else if (isRegExp(obj)) {
      // TODO: consider /u support
      if (obj.ignoreCase) throw new Error('RegExp /i flag not allowed')
      if (obj.global) throw new Error('RegExp /g flag is implied')
      if (obj.sticky) throw new Error('RegExp /y flag is implied')
      if (obj.multiline) throw new Error('RegExp /m flag is implied')
      return obj.source

    } else {
      throw new Error('Not a pattern: ' + obj)
    }
  }

  function pad(s, length) {
    if (s.length > length) {
      return s
    }
    return Array(length - s.length + 1).join(" ") + s
  }

  function lastNLines(string, numLines) {
    var position = string.length
    var lineBreaks = 0;
    while (true) {
      var idx = string.lastIndexOf("\n", position - 1)
      if (idx === -1) {
        break;
      } else {
        lineBreaks++
      }
      position = idx
      if (lineBreaks === numLines) {
        break;
      }
      if (position === 0) {
        break;
      }
    }
    var startPosition = 
      lineBreaks < numLines ?
      0 : 
      position + 1
    return string.substring(startPosition).split("\n")
  }

  function objectToRules(object) {
    var keys = Object.getOwnPropertyNames(object)
    var result = []
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      var thing = object[key]
      var rules = [].concat(thing)
      if (key === 'include') {
        for (var j = 0; j < rules.length; j++) {
          result.push({include: rules[j]})
        }
        continue
      }
      var match = []
      rules.forEach(function(rule) {
        if (isObject(rule)) {
          if (match.length) result.push(ruleOptions(key, match))
          result.push(ruleOptions(key, rule))
          match = []
        } else {
          match.push(rule)
        }
      })
      if (match.length) result.push(ruleOptions(key, match))
    }
    return result
  }

  function arrayToRules(array) {
    var result = []
    for (var i = 0; i < array.length; i++) {
      var obj = array[i]
      if (obj.include) {
        var include = [].concat(obj.include)
        for (var j = 0; j < include.length; j++) {
          result.push({include: include[j]})
        }
        continue
      }
      if (!obj.type) {
        throw new Error('Rule has no type: ' + JSON.stringify(obj))
      }
      result.push(ruleOptions(obj.type, obj))
    }
    return result
  }

  function ruleOptions(type, obj) {
    if (!isObject(obj)) {
      obj = { match: obj }
    }
    if (obj.include) {
      throw new Error('Matching rules cannot also include states')
    }

    // nb. error and fallback imply lineBreaks
    var options = {
      defaultType: type,
      lineBreaks: !!obj.error || !!obj.fallback,
      pop: false,
      next: null,
      push: null,
      error: false,
      fallback: false,
      value: null,
      type: null,
      shouldThrow: false,
    }

    // Avoid Object.assign(), so we support IE9+
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) {
        options[key] = obj[key]
      }
    }

    // type transform cannot be a string
    if (typeof options.type === 'string' && type !== options.type) {
      throw new Error("Type transform cannot be a string (type '" + options.type + "' for token '" + type + "')")
    }

    // convert to array
    var match = options.match
    options.match = Array.isArray(match) ? match : match ? [match] : []
    options.match.sort(function(a, b) {
      return isRegExp(a) && isRegExp(b) ? 0
           : isRegExp(b) ? -1 : isRegExp(a) ? +1 : b.length - a.length
    })
    return options
  }

  function toRules(spec) {
    return Array.isArray(spec) ? arrayToRules(spec) : objectToRules(spec)
  }

  var defaultErrorRule = ruleOptions('error', {lineBreaks: true, shouldThrow: true})
  function compileRules(rules, hasStates) {
    var errorRule = null
    var fast = Object.create(null)
    var fastAllowed = true
    var unicodeFlag = null
    var groups = []
    var parts = []

    // If there is a fallback rule, then disable fast matching
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].fallback) {
        fastAllowed = false
      }
    }

    for (var i = 0; i < rules.length; i++) {
      var options = rules[i]

      if (options.include) {
        // all valid inclusions are removed by states() preprocessor
        throw new Error('Inheritance is not allowed in stateless lexers')
      }

      if (options.error || options.fallback) {
        // errorRule can only be set once
        if (errorRule) {
          if (!options.fallback === !errorRule.fallback) {
            throw new Error("Multiple " + (options.fallback ? "fallback" : "error") + " rules not allowed (for token '" + options.defaultType + "')")
          } else {
            throw new Error("fallback and error are mutually exclusive (for token '" + options.defaultType + "')")
          }
        }
        errorRule = options
      }

      var match = options.match.slice()
      if (fastAllowed) {
        while (match.length && typeof match[0] === 'string' && match[0].length === 1) {
          var word = match.shift()
          fast[word.charCodeAt(0)] = options
        }
      }

      // Warn about inappropriate state-switching options
      if (options.pop || options.push || options.next) {
        if (!hasStates) {
          throw new Error("State-switching options are not allowed in stateless lexers (for token '" + options.defaultType + "')")
        }
        if (options.fallback) {
          throw new Error("State-switching options are not allowed on fallback tokens (for token '" + options.defaultType + "')")
        }
      }

      // Only rules with a .match are included in the RegExp
      if (match.length === 0) {
        continue
      }
      fastAllowed = false

      groups.push(options)

      // Check unicode flag is used everywhere or nowhere
      for (var j = 0; j < match.length; j++) {
        var obj = match[j]
        if (!isRegExp(obj)) {
          continue
        }

        if (unicodeFlag === null) {
          unicodeFlag = obj.unicode
        } else if (unicodeFlag !== obj.unicode && options.fallback === false) {
          throw new Error('If one rule is /u then all must be')
        }
      }

      // convert to RegExp
      var pat = reUnion(match.map(regexpOrLiteral))

      // validate
      var regexp = new RegExp(pat)
      if (regexp.test("")) {
        throw new Error("RegExp matches empty string: " + regexp)
      }
      var groupCount = reGroups(pat)
      if (groupCount > 0) {
        throw new Error("RegExp has capture groups: " + regexp + "\nUse (?: … ) instead")
      }

      // try and detect rules matching newlines
      if (!options.lineBreaks && regexp.test('\n')) {
        throw new Error('Rule should declare lineBreaks: ' + regexp)
      }

      // store regex
      parts.push(reCapture(pat))
    }


    // If there's no fallback rule, use the sticky flag so we only look for
    // matches at the current index.
    //
    // If we don't support the sticky flag, then fake it using an irrefutable
    // match (i.e. an empty pattern).
    var fallbackRule = errorRule && errorRule.fallback
    var flags = hasSticky && !fallbackRule ? 'ym' : 'gm'
    var suffix = hasSticky || fallbackRule ? '' : '|'

    if (unicodeFlag === true) flags += "u"
    var combined = new RegExp(reUnion(parts) + suffix, flags)
    return {regexp: combined, groups: groups, fast: fast, error: errorRule || defaultErrorRule}
  }

  function compile(rules) {
    var result = compileRules(toRules(rules))
    return new Lexer({start: result}, 'start')
  }

  function checkStateGroup(g, name, map) {
    var state = g && (g.push || g.next)
    if (state && !map[state]) {
      throw new Error("Missing state '" + state + "' (in token '" + g.defaultType + "' of state '" + name + "')")
    }
    if (g && g.pop && +g.pop !== 1) {
      throw new Error("pop must be 1 (in token '" + g.defaultType + "' of state '" + name + "')")
    }
  }
  function compileStates(states, start) {
    var all = states.$all ? toRules(states.$all) : []
    delete states.$all

    var keys = Object.getOwnPropertyNames(states)
    if (!start) start = keys[0]

    var ruleMap = Object.create(null)
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      ruleMap[key] = toRules(states[key]).concat(all)
    }
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      var rules = ruleMap[key]
      var included = Object.create(null)
      for (var j = 0; j < rules.length; j++) {
        var rule = rules[j]
        if (!rule.include) continue
        var splice = [j, 1]
        if (rule.include !== key && !included[rule.include]) {
          included[rule.include] = true
          var newRules = ruleMap[rule.include]
          if (!newRules) {
            throw new Error("Cannot include nonexistent state '" + rule.include + "' (in state '" + key + "')")
          }
          for (var k = 0; k < newRules.length; k++) {
            var newRule = newRules[k]
            if (rules.indexOf(newRule) !== -1) continue
            splice.push(newRule)
          }
        }
        rules.splice.apply(rules, splice)
        j--
      }
    }

    var map = Object.create(null)
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      map[key] = compileRules(ruleMap[key], true)
    }

    for (var i = 0; i < keys.length; i++) {
      var name = keys[i]
      var state = map[name]
      var groups = state.groups
      for (var j = 0; j < groups.length; j++) {
        checkStateGroup(groups[j], name, map)
      }
      var fastKeys = Object.getOwnPropertyNames(state.fast)
      for (var j = 0; j < fastKeys.length; j++) {
        checkStateGroup(state.fast[fastKeys[j]], name, map)
      }
    }

    return new Lexer(map, start)
  }

  function keywordTransform(map) {

    // Use a JavaScript Map to map keywords to their corresponding token type
    // unless Map is unsupported, then fall back to using an Object:
    var isMap = typeof Map !== 'undefined'
    var reverseMap = isMap ? new Map : Object.create(null)

    var types = Object.getOwnPropertyNames(map)
    for (var i = 0; i < types.length; i++) {
      var tokenType = types[i]
      var item = map[tokenType]
      var keywordList = Array.isArray(item) ? item : [item]
      keywordList.forEach(function(keyword) {
        if (typeof keyword !== 'string') {
          throw new Error("keyword must be string (in keyword '" + tokenType + "')")
        }
        if (isMap) {
          reverseMap.set(keyword, tokenType)
        } else {
          reverseMap[keyword] = tokenType
        }
      })
    }
    return function(k) {
      return isMap ? reverseMap.get(k) : reverseMap[k]
    }
  }

  /***************************************************************************/

  var Lexer = function(states, state) {
    this.startState = state
    this.states = states
    this.buffer = ''
    this.stack = []
    this.reset()
  }

  Lexer.prototype.reset = function(data, info) {
    this.buffer = data || ''
    this.index = 0
    this.line = info ? info.line : 1
    this.col = info ? info.col : 1
    this.queuedToken = info ? info.queuedToken : null
    this.queuedText = info ? info.queuedText: "";
    this.queuedThrow = info ? info.queuedThrow : null
    this.setState(info ? info.state : this.startState)
    this.stack = info && info.stack ? info.stack.slice() : []
    return this
  }

  Lexer.prototype.save = function() {
    return {
      line: this.line,
      col: this.col,
      state: this.state,
      stack: this.stack.slice(),
      queuedToken: this.queuedToken,
      queuedText: this.queuedText,
      queuedThrow: this.queuedThrow,
    }
  }

  Lexer.prototype.setState = function(state) {
    if (!state || this.state === state) return
    this.state = state
    var info = this.states[state]
    this.groups = info.groups
    this.error = info.error
    this.re = info.regexp
    this.fast = info.fast
  }

  Lexer.prototype.popState = function() {
    this.setState(this.stack.pop())
  }

  Lexer.prototype.pushState = function(state) {
    this.stack.push(this.state)
    this.setState(state)
  }

  var eat = hasSticky ? function(re, buffer) { // assume re is /y
    return re.exec(buffer)
  } : function(re, buffer) { // assume re is /g
    var match = re.exec(buffer)
    // will always match, since we used the |(?:) trick
    if (match[0].length === 0) {
      return null
    }
    return match
  }

  Lexer.prototype._getGroup = function(match) {
    var groupCount = this.groups.length
    for (var i = 0; i < groupCount; i++) {
      if (match[i + 1] !== undefined) {
        return this.groups[i]
      }
    }
    throw new Error('Cannot find token type for matched text')
  }

  function tokenToString() {
    return this.value
  }

  Lexer.prototype.next = function() {
    var index = this.index

    // If a fallback token matched, we don't need to re-run the RegExp
    if (this.queuedGroup) {
      var token = this._token(this.queuedGroup, this.queuedText, index)
      this.queuedGroup = null
      this.queuedText = ""
      return token
    }

    var buffer = this.buffer
    if (index === buffer.length) {
      return // EOF
    }

    // Fast matching for single characters
    var group = this.fast[buffer.charCodeAt(index)]
    if (group) {
      return this._token(group, buffer.charAt(index), index)
    }

    // Execute RegExp
    var re = this.re
    re.lastIndex = index
    var match = eat(re, buffer)

    // Error tokens match the remaining buffer
    var error = this.error
    if (match == null) {
      return this._token(error, buffer.slice(index, buffer.length), index)
    }

    var group = this._getGroup(match)
    var text = match[0]

    if (error.fallback && match.index !== index) {
      this.queuedGroup = group
      this.queuedText = text

      // Fallback tokens contain the unmatched portion of the buffer
      return this._token(error, buffer.slice(index, match.index), index)
    }

    return this._token(group, text, index)
  }

  Lexer.prototype._token = function(group, text, offset) {
    // count line breaks
    var lineBreaks = 0
    if (group.lineBreaks) {
      var matchNL = /\n/g
      var nl = 1
      if (text === '\n') {
        lineBreaks = 1
      } else {
        while (matchNL.exec(text)) { lineBreaks++; nl = matchNL.lastIndex }
      }
    }

    var token = {
      type: (typeof group.type === 'function' && group.type(text)) || group.defaultType,
      value: typeof group.value === 'function' ? group.value(text) : text,
      text: text,
      toString: tokenToString,
      offset: offset,
      lineBreaks: lineBreaks,
      line: this.line,
      col: this.col,
    }
    // nb. adding more props to token object will make V8 sad!

    var size = text.length
    this.index += size
    this.line += lineBreaks
    if (lineBreaks !== 0) {
      this.col = size - nl + 1
    } else {
      this.col += size
    }

    // throw, if no rule with {error: true}
    if (group.shouldThrow) {
      var err = new Error(this.formatError(token, "invalid syntax"))
      throw err;
    }

    if (group.pop) this.popState()
    else if (group.push) this.pushState(group.push)
    else if (group.next) this.setState(group.next)

    return token
  }

  if (typeof Symbol !== 'undefined' && Symbol.iterator) {
    var LexerIterator = function(lexer) {
      this.lexer = lexer
    }

    LexerIterator.prototype.next = function() {
      var token = this.lexer.next()
      return {value: token, done: !token}
    }

    LexerIterator.prototype[Symbol.iterator] = function() {
      return this
    }

    Lexer.prototype[Symbol.iterator] = function() {
      return new LexerIterator(this)
    }
  }

  Lexer.prototype.formatError = function(token, message) {
    if (token == null) {
      // An undefined token indicates EOF
      var text = this.buffer.slice(this.index)
      var token = {
        text: text,
        offset: this.index,
        lineBreaks: text.indexOf('\n') === -1 ? 0 : 1,
        line: this.line,
        col: this.col,
      }
    }
    
    var numLinesAround = 2
    var firstDisplayedLine = Math.max(token.line - numLinesAround, 1)
    var lastDisplayedLine = token.line + numLinesAround
    var lastLineDigits = String(lastDisplayedLine).length
    var displayedLines = lastNLines(
        this.buffer, 
        (this.line - token.line) + numLinesAround + 1
      )
      .slice(0, 5)
    var errorLines = []
    errorLines.push(message + " at line " + token.line + " col " + token.col + ":")
    errorLines.push("")
    for (var i = 0; i < displayedLines.length; i++) {
      var line = displayedLines[i]
      var lineNo = firstDisplayedLine + i
      errorLines.push(pad(String(lineNo), lastLineDigits) + "  " + line);
      if (lineNo === token.line) {
        errorLines.push(pad("", lastLineDigits + token.col + 1) + "^")
      }
    }
    return errorLines.join("\n")
  }

  Lexer.prototype.clone = function() {
    return new Lexer(this.states, this.state)
  }

  Lexer.prototype.has = function(tokenType) {
    return true
  }


  return {
    compile: compile,
    states: compileStates,
    error: Object.freeze({error: true}),
    fallback: Object.freeze({fallback: true}),
    keywords: keywordTransform,
  }

}));


/***/ }),

/***/ 731:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SIMPLE_TYPES = exports.INTEGER_TYPES = void 0;
exports.normalizeType = normalizeType;
const numericTypeMap = {
    "unsigned short": "uint16",
    "unsigned long": "uint32",
    "unsigned long long": "uint64",
    short: "int16",
    long: "int32",
    "long long": "int64",
    double: "float64",
    float: "float32",
    octet: "uint8",
    char: "uint8",
    byte: "int8",
};
exports.INTEGER_TYPES = new Set([
    "int8",
    "uint8",
    "int16",
    "uint16",
    "int32",
    "uint32",
    "int64",
    "uint64",
    "byte",
    "octet",
    "unsigned short",
    "unsigned long",
    "unsigned long long",
    "short",
    "long",
    "long long",
]);
exports.SIMPLE_TYPES = new Set([
    "bool",
    "string",
    "wstring",
    "int8",
    "uint8",
    "int16",
    "uint16",
    "int32",
    "uint32",
    "int64",
    "uint64",
    "wchar",
    ...Object.keys(numericTypeMap),
]);
function normalizeType(type) {
    const toType = numericTypeMap[type];
    if (toType != undefined) {
        return toType;
    }
    return type;
}


/***/ }),

/***/ 774:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EnumIDLNode = void 0;
const IDLNode_1 = __webpack_require__(165);
/** Class used to resolve an Enum ASTNode to an IDLMessageDefinition */
class EnumIDLNode extends IDLNode_1.IDLNode {
    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    get type() {
        return "uint32";
    }
    enumeratorNodes() {
        return this.astNode.enumerators.map((enumerator) => this.getConstantNode((0, IDLNode_1.toScopedIdentifier)([...this.scopePath, this.name, enumerator.name])));
    }
    toIDLMessageDefinition() {
        const definitions = this.enumeratorNodes().map((enumerator) => enumerator.toIDLMessageDefinitionField());
        return {
            name: (0, IDLNode_1.toScopedIdentifier)([...this.scopePath, this.name]),
            definitions,
            // Going to use the module aggregated kind since that's what we store constants in
            aggregatedKind: "module",
        };
    }
}
exports.EnumIDLNode = EnumIDLNode;


/***/ }),

/***/ 791:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseIDL = parseIDL;
const parseIDLToAST_1 = __webpack_require__(128);
const processIDL_1 = __webpack_require__(177);
/**
 * Parses IDL schema to flattened IDLMessageDefinitions that can be used to serialize/deserialize messages
 * @param messageDefinition - idl decoded message definition string
 * @returns - parsed message definition with annotations
 */
function parseIDL(messageDefinition) {
    const rawIDLDefinitions = (0, parseIDLToAST_1.parseIDLToAST)(messageDefinition);
    const idlMap = (0, processIDL_1.buildMap)(rawIDLDefinitions);
    return (0, processIDL_1.toIDLMessageDefinitions)(idlMap);
}


/***/ }),

/***/ 836:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IDL_GRAMMAR = void 0;
const nearley_1 = __webpack_require__(662);
const idl_ne_1 = __importDefault(__webpack_require__(506));
exports.IDL_GRAMMAR = nearley_1.Grammar.fromCompiled(idl_ne_1.default);


/***/ }),

/***/ 852:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReferenceTypeIDLNode = void 0;
const IDLNode_1 = __webpack_require__(165);
const primitiveTypes_1 = __webpack_require__(731);
/** Class used for struct members and typedefs because they can reference each other and other types (enum and struct)
 * This class resolves the fields of these types to their final values.
 */
class ReferenceTypeIDLNode extends IDLNode_1.IDLNode {
    /** Indicates that it references another typedef, enum or struct. (ie: uses a non-builtin / simple type) */
    typeNeedsResolution = false;
    /** Used to hold an optional referenced node if needsResolution==true. Resolved/Set with `typeRef()` function.
     * Not meant to be used outside of `typeRef()` function.
     */
    typeRefNode;
    constructor(scopePath, astNode, idlMap) {
        super(scopePath, astNode, idlMap);
        if (!primitiveTypes_1.SIMPLE_TYPES.has(astNode.type)) {
            this.typeNeedsResolution = true;
        }
    }
    get type() {
        if (this.typeNeedsResolution) {
            const parent = this.typeRef();
            if (parent.declarator === "typedef" || parent.declarator === "enum") {
                return parent.type;
            }
            return parent.scopedIdentifier;
        }
        return this.astNode.type;
    }
    get isComplex() {
        if (!this.typeNeedsResolution) {
            return false;
        }
        const parent = this.typeRef();
        if (parent.declarator === "typedef") {
            return parent.isComplex;
        }
        return parent.declarator === "struct" || parent.declarator === "union";
    }
    get enumType() {
        if (this.typeNeedsResolution) {
            const parent = this.typeRef();
            if (parent.declarator === "enum") {
                return parent.scopedIdentifier;
            }
        }
        return undefined;
    }
    get isArray() {
        let isArray = this.astNode.isArray;
        if (this.typeNeedsResolution) {
            const parent = this.typeRef();
            if (parent.declarator === "typedef") {
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                isArray ||= parent.isArray;
            }
        }
        return isArray;
    }
    get arrayLengths() {
        // Arraylengths are composed such that the prior arrayLengths describe the outermost arrays.
        // This means that the arrayLengths on the typedef should be pushed to the end as innermost arrayLengths.
        const arrayLengths = this.astNode.arrayLengths ? [...this.astNode.arrayLengths] : [];
        if (this.typeNeedsResolution) {
            const parent = this.typeRef();
            if (parent.declarator === "typedef" && parent.arrayLengths) {
                arrayLengths.push(...parent.arrayLengths);
            }
        }
        const finalArrayLengths = [];
        // Resolve constant usage in arraylengths
        for (const arrayLength of arrayLengths) {
            const resolvedArrayLength = this.resolvePossibleNumericConstantUsage(arrayLength);
            // Shouldn't return undefined since the arrayLengths array should never include undefined
            if (resolvedArrayLength != undefined) {
                finalArrayLengths.push(resolvedArrayLength);
            }
        }
        return finalArrayLengths.length > 0 ? finalArrayLengths : undefined;
    }
    get arrayUpperBound() {
        let arrayUpperBound = undefined;
        if (this.typeNeedsResolution) {
            const parent = this.typeRef();
            if (parent.declarator === "typedef") {
                arrayUpperBound = parent.arrayUpperBound;
            }
        }
        if (this.astNode.arrayUpperBound != undefined) {
            // Note: we forbid variable length array composition, so this won't be overriding the parent value
            arrayUpperBound = this.astNode.arrayUpperBound;
        }
        return this.resolvePossibleNumericConstantUsage(arrayUpperBound);
    }
    get upperBound() {
        let upperBound = undefined;
        if (this.typeNeedsResolution) {
            const parent = this.typeRef();
            if (parent.declarator === "typedef") {
                upperBound = parent.upperBound;
            }
        }
        if (this.astNode.upperBound != undefined) {
            // Note: we forbid variable length array composition, so this won't be overriding the parent value
            upperBound = this.astNode.upperBound;
        }
        // Check for constant usage
        return this.resolvePossibleNumericConstantUsage(upperBound);
    }
    get annotations() {
        let annotations = undefined;
        if (this.typeNeedsResolution) {
            const parent = this.typeRef();
            // We do not want to inherit annotations from a struct or enum
            if (parent.declarator === "typedef" && parent.annotations != undefined) {
                annotations = { ...parent.annotations };
            }
        }
        if (this.astNode.annotations != undefined) {
            // prioritize the astNode annotations
            annotations = { ...annotations, ...this.astNode.annotations };
        }
        return annotations;
    }
    resolvePossibleNumericConstantUsage(astValue) {
        if (typeof astValue === "number" || astValue == undefined) {
            return astValue;
        }
        const constantNodeIdentifier = astValue.name;
        const constantNodeValue = this.getConstantNode(constantNodeIdentifier).value; // should never be undefined
        if (typeof constantNodeValue !== "number") {
            throw Error(`Expected constant value ${constantNodeIdentifier} in ${this.scopedIdentifier} to be a number, but got ${constantNodeValue.toString()}`);
        }
        return constantNodeValue;
    }
    /** Gets Node with the given name in the current instance's scope and checks that it is a valid type reference node */
    getValidTypeReference(typeName) {
        const maybeValidParent = this.getNode(this.scopePath, typeName);
        if (!(maybeValidParent.declarator === "struct") &&
            !(maybeValidParent.declarator === "typedef") &&
            !(maybeValidParent.declarator === "union") &&
            !(maybeValidParent.declarator === "enum")) {
            throw new Error(`Expected ${typeName} to be non-module, non-constant type in ${this.scopedIdentifier}`);
        }
        return maybeValidParent;
    }
    /** Resolves to a type reference node value or fails if one is not found.
     * Only to be used when needsResolution==true and the `type` on the astNode is not "simple".
     * Also checks the parent against current serialization limitations. (ie: we do not support composing variable length arrays with typedefs)
     */
    typeRef() {
        this.typeRefNode ??= this.getValidTypeReference(this.astNode.type);
        if (!(this.typeRefNode instanceof ReferenceTypeIDLNode)) {
            return this.typeRefNode;
        }
        // check potential errors
        if (this.astNode.isArray === true && this.typeRefNode.isArray === true) {
            const thisNodeIsFixedSize = this.astNode.arrayLengths != undefined;
            const parentNodeIsFixedSize = this.typeRefNode.arrayLengths != undefined;
            if (!thisNodeIsFixedSize || !parentNodeIsFixedSize) {
                throw new Error(`We do not support composing variable length arrays with typedefs: ${this.scopedIdentifier} referencing ${this.typeRefNode.scopedIdentifier}`);
            }
        }
        return this.typeRefNode;
    }
}
exports.ReferenceTypeIDLNode = ReferenceTypeIDLNode;


/***/ }),

/***/ 877:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConstantIDLNode = void 0;
const EnumIDLNode_1 = __webpack_require__(774);
const IDLNode_1 = __webpack_require__(165);
const primitiveTypes_1 = __webpack_require__(731);
/** Wraps constant node so that its type and value can be resolved and written to a message definition */
class ConstantIDLNode extends IDLNode_1.IDLNode {
    /** If the type needs resolution (not simple primitive) this will be set to true. Should only ever mean that it's referencing an enum */
    typeNeedsResolution = false;
    constructor(scopePath, astNode, idlMap) {
        super(scopePath, astNode, idlMap);
        if (!primitiveTypes_1.SIMPLE_TYPES.has(astNode.type)) {
            this.typeNeedsResolution = true;
        }
    }
    get type() {
        if (this.typeNeedsResolution) {
            return this.getReferencedEnumNode().type;
        }
        return this.astNode.type;
    }
    /** Holds reference so that it doesn't need to be searched for again */
    referencedEnumNode = undefined;
    /** Gets enum node referenced by type. Fails otherwise. */
    getReferencedEnumNode() {
        if (this.referencedEnumNode == undefined) {
            const maybeEnumNode = this.getNode(this.scopePath, this.astNode.type);
            if (!(maybeEnumNode instanceof EnumIDLNode_1.EnumIDLNode)) {
                throw new Error(`Expected ${this.astNode.type} to be an enum in ${this.scopedIdentifier}`);
            }
            this.referencedEnumNode = maybeEnumNode;
        }
        return this.referencedEnumNode;
    }
    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    get isConstant() {
        return true;
    }
    /** Return Literal value on astNode or if the constant references another constant, then it gets the value that constant uses */
    get value() {
        if (typeof this.astNode.value === "object") {
            return this.getConstantNode(this.astNode.value.name).value;
        }
        return this.astNode.value;
    }
    /** Writes resolved IDLMessageDefinition */
    toIDLMessageDefinitionField() {
        return {
            name: this.name,
            type: (0, primitiveTypes_1.normalizeType)(this.type),
            value: this.value,
            isConstant: true,
            isComplex: false,
            ...(this.astNode.valueText != undefined ? { valueText: this.astNode.valueText } : undefined),
        };
    }
}
exports.ConstantIDLNode = ConstantIDLNode;


/***/ }),

/***/ 881:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(791), exports);
__exportStar(__webpack_require__(428), exports);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(881);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.js.map